// This file is now empty.
// Its contents have been moved to the more specific files
// in the `packages/dev/src/groq/common/` directory.
// It can be deleted.

$$DELETE_FILE$$;
